import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api, { formatApiErrorDetail } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Card } from "../components/ui/card";
import { toast } from "sonner";
import { Loader2, KeyRound, CheckCircle2 } from "lucide-react";

export default function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 6) return setError("La password deve avere almeno 6 caratteri.");
    if (password !== confirm) return setError("Le password non coincidono.");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
      toast.success("Password aggiornata");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#F2F4F5] flex flex-col items-center justify-center px-4">
      <img src="/nexus_logo.png" alt="Nexus Italia Group" className="h-11 w-auto object-contain mb-6" />
      <Card className="w-full max-w-md p-8 border-slate-200 nx-fade-in">
        {done ? (
          <div className="text-center">
            <CheckCircle2 className="h-12 w-12 text-emerald-600 mx-auto mb-4" />
            <h2 className="text-xl font-bold font-heading text-slate-900 mb-2">Password aggiornata</h2>
            <p className="text-sm text-slate-500 mb-6">Ora puoi accedere con la tua nuova password.</p>
            <Button data-testid="go-login" className="w-full" onClick={() => navigate("/login")}>Vai al Login</Button>
          </div>
        ) : (
          <>
            <div className="flex items-center gap-2 mb-1">
              <KeyRound className="h-5 w-5 text-primary" />
              <h2 className="text-xl font-bold font-heading text-slate-900">Reimposta Password</h2>
            </div>
            <p className="text-sm text-slate-500 mb-6">Scegli una nuova password per il tuo account.</p>
            {error && <div data-testid="reset-error" className="mb-4 rounded-md bg-red-50 border border-red-200 px-4 py-2.5 text-sm text-red-700">{error}</div>}
            <form onSubmit={submit} className="space-y-4">
              <div>
                <Label className="nx-label">Nuova Password</Label>
                <Input data-testid="reset-password" type="password" required className="mt-1.5"
                  value={password} onChange={(e) => setPassword(e.target.value)} />
              </div>
              <div>
                <Label className="nx-label">Conferma Password</Label>
                <Input data-testid="reset-confirm" type="password" required className="mt-1.5"
                  value={confirm} onChange={(e) => setConfirm(e.target.value)} />
              </div>
              <Button data-testid="reset-submit" type="submit" disabled={loading} className="w-full">
                {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Aggiorna Password"}
              </Button>
            </form>
          </>
        )}
      </Card>
    </div>
  );
}
